module.exports = __webpack_public_path__ + "img/productHSE_15.a13f95f7.png";